import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* getCustomerSegmentsCountWatcherSaga() {
  yield takeLatest(types.GET_CUSTOMER_SEGMENTS_COUNT_API_CALL_REQUEST, workerSaga);
}

export function fetchData() {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/consumer/${client}/consumer-count/`;



  return axios.get(url)
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga() {
  try {
    const response = yield call(fetchData);
    if (response && response.status === 200) {
      const { data } = response;

      yield put({ type: types.GET_CUSTOMER_SEGMENTS_COUNT_API_CALL_SUCCESS, data });
    } else {
      yield put({ type: types.GET_CUSTOMER_SEGMENTS_COUNT_API_CALL_FAILURE, error: 'error occured during get customer segments count' });
    }
  } catch (error) {
    yield put({ type: types.GET_CUSTOMER_SEGMENTS_COUNT_API_CALL_FAILURE, error });
  }
}
